// extracted by mini-css-extract-plugin
export default {"introText":"intro_introText__UkgxO"};